// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"3cef8317","188":"c9d58269","205":"319467bc","385":"1a37378f","417":"93ced934","482":"d402047d","488":"eadfa0b8","653":"a7a90fa7","827":"c1cd2f1f","835":"a2bbc17a"}[chunkId] + ".chunk.js";
};